import "../Styles/MainPage.css";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import orderSuccess from "../Images/orderSucess.png";
import { setLanguage } from "../store/action/language/language";
import { useDispatch, useSelector } from "react-redux";

function OrderRecieved(props) {
  const { t, i18n } = useTranslation();
  const languageState = useSelector((state) => state.language);
  const dispatch = useDispatch();
  const history = useNavigate();

  //checks language and translates screen and page title accordingly
  useEffect(() => {
    const handleLanguage = () => {
      const data = window.localStorage.getItem("LANGUAGE");
      if (data !== null) {
        const { language, x } = JSON.parse(data);
        i18n.changeLanguage(language);
        document.getElementById("root").style.direction = x;
        dispatch(setLanguage(language, x));
      } else {
        // Fallback to Redux state if localStorage is not available
        const lang = languageState.lang || "en";
        const dir = languageState.dir || "ltr";
        i18n.changeLanguage(lang);
        document.getElementById("root").style.direction = dir;
      }
      document.title =
        i18n.language === "ar" ? "مطاعم الرومانسية" : "Al Romansiah Restaurant";
    };
    handleLanguage();
  }, [dispatch, languageState.lang, languageState.dir, i18n]);

  const handleInvoice = () => {
    const orderId = localStorage.getItem("orderId");
    const orderQueueId = localStorage.getItem("orderQueueId") || "";
    const id = `${orderId}-${orderQueueId.substring(1)}`;
    history(`/invoice/${id}`);
  };

  const orderId = localStorage.getItem("orderId");
  const canShowInvoice = orderId != null && orderId !== "";

  return (
    <div
      className="container"
      style={{
        height: "100vh",
        backgroundImage: `url(${orderSuccess})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
      }}
    >
      <div
        className={languageState.lang === "ar" || languageState.lang === "ur" ? "orderBtns" : "orderBtnsEn"}
        style={{
          padding: "1.5em",
          marginBottom: "2em",
        }}
      >
        <Link to="/menu/meals">
          <button>{t("Basket.orderBtn")}</button>
        </Link>
        {canShowInvoice && (
          <button className="invoiceBtn" onClick={handleInvoice}>
            {t("Basket.invoice")}
          </button>
        )}
      </div>
    </div>
  );
}
export default OrderRecieved;
